import { atom } from 'recoil';
import { IVisitWithProgramTitle } from '../layouts/reports/ReportLayout';
export const visitAtom = atom({
  key: 'visit',
  default: {} as IVisitWithProgramTitle | undefined,
});
